import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Http } from '@angular/http';

@Component({
  selector: 'app-send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.scss']
})
export class SendMessageComponent implements OnInit {
  form: FormGroup;
  formErrors: any;
  roles: string;
  company: any;
  users = new BehaviorSubject<any[]>([]);
  sub: any;
  constructor(
    private formBuilder: FormBuilder,
    private http: Http,

  ) {
    this.formErrors = {
      text: {}
    };
  }

  ngOnInit() {
    this.roles = localStorage.getItem('currentUserRole');
    this.form = this.formBuilder.group({
      text: ['', Validators.required]
    });

    this.form.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });

  }

  onFormValuesChanged() {
    for (const field in this.formErrors) {
      if (!this.formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.formErrors[field] = {};

      // Get the control
      const control = this.form.get(field);

      if (control && control.dirty && !control.valid) {
        this.formErrors[field] = control.errors;
      }
    }
  }

  changeText(string) {
    return string.trim()
      .replace(/\)/g, '')
      .replace(/\(/g, '')
      .replace(/\-/g, '')
      .replace(/\s/g, '');

  }

  send() {


    // this.http.post("https://api.bulutfon.com/messages", {
    //   title: "bigadvice",
    //   receivers: "+90" + 5535785961,
    //   content: "Merhaba, evde hayat nasıl gidiyor :)",
    //   reject_link: false,
    //   access_token: "9263bfff99e749c491218c4afa4282b5e404766c782a06031bcbdff8d1dc5cfd"
    // }).map(res => res.json()).subscribe(a => {
    //   console.log(a)
    // })



    // this.sub = this.users.subscribe((data: any) => {
    //   if (data.phoneNumber) {
    //     this.http.post("https://api.bulutfon.com/messages", {
    //       title: "bigadvice",
    //       receivers: "+90" + this.changeText(data.phoneNumber),
    //       content: data.customMessage,
    //       reject_link: false,
    //       access_token: "9263bfff99e749c491218c4afa4282b5e404766c782a06031bcbdff8d1dc5cfd"
    //     }).map(res => res.json()).subscribe();
    //   }
    // });


    this.form.reset();
  }
  ngOnDestroy(): void {
    try {
      this.sub.unsubscribe();
    } catch (e) { }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/send-message/send-message.component.ts